/* ============================================================
   CARBON — global front-end utilities
   - Scroll reveal (IntersectionObserver)
   - Tiny pub/sub for cart updates across sections
   ============================================================ */
(function () {
  'use strict';

  /* ---------- Scroll reveal ---------- */
  function initReveal(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('[data-c-reveal]:not(.is-visible)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            obs.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Lightweight event bus (cart) ---------- */
  var Carbon = (window.Carbon = window.Carbon || {});
  Carbon.bus = Carbon.bus || document.createElement('div');
  Carbon.emit = function (name, detail) {
    Carbon.bus.dispatchEvent(new CustomEvent(name, { detail: detail }));
  };
  Carbon.on = function (name, fn) { Carbon.bus.addEventListener(name, fn); };
  Carbon.initReveal = initReveal;

  /* Fetch cart state helper */
  Carbon.getCart = function () {
    return fetch(window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js', { headers: { Accept: 'application/json' } }
    ).then(function (r) { return r.json(); });
  };

  /* ---------- Global quick-add (delegated) ---------- */
  var routesRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    var id = btn.getAttribute('data-variant-id');
    if (!id || btn.classList.contains('is-loading')) return;

    btn.classList.add('is-loading');
    var label = btn.querySelector('.c-pc__add-label');
    var prev = label ? label.textContent : null;
    if (label) label.textContent = 'Adding…';

    fetch(routesRoot + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
      .then(function (res) {
        if (!res.ok) throw res.data;
        return Carbon.getCart();
      })
      .then(function (cart) {
        Carbon.emit('cart:update', cart);
        Carbon.emit('cart:add', cart);
        if (label) label.textContent = 'Added ✓';
        setTimeout(function () { if (label && prev) label.textContent = prev; }, 1400);
      })
      .catch(function () { if (label && prev) label.textContent = prev; })
      .finally(function () { btn.classList.remove('is-loading'); });
  });

  /* Init on load + after Shopify section re-render in the editor */
  document.addEventListener('DOMContentLoaded', function () { initReveal(); });
  if (document.readyState !== 'loading') initReveal();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });
})();
